import { Injectable } from '@angular/core';
import {
  Rppk14CardRow,
  Rppk14SubscriptionGroup,
  Rppk14TableResult,
  Rppk14Totals,
  Rppk14VehicleTypeGroup,
} from '../../models/report/rppk14.model';

@Injectable({ providedIn: 'root' })
export class MapperRppk14Service {
  mapTable(res: unknown): Rppk14TableResult {
    const raw = (res ?? {}) as Record<string, unknown>;
    const groups = (raw['groups'] ?? raw['Groups'] ?? []) as unknown[];
    return {
      siteName: String(raw['siteName'] ?? raw['SiteName'] ?? ''),
      siteAddress: String(raw['siteAddress'] ?? raw['SiteAddress'] ?? ''),
      siteTaxId: String(raw['siteTaxId'] ?? raw['SiteTaxId'] ?? ''),
      groups: groups.map((g) => this.mapVehicleGroup(g)),
      totals: this.mapTotals(raw['totals'] ?? raw['Totals'] ?? {}),
    };
  }

  private mapVehicleGroup(dto: unknown): Rppk14VehicleTypeGroup {
    const g = (dto ?? {}) as Record<string, unknown>;
    const subs = (g['subscriptions'] ?? g['Subscriptions'] ?? []) as unknown[];
    return {
      vehicleTypeId: Number(g['vehicleTypeId'] ?? g['VehicleTypeId'] ?? 0),
      vehicleTypeName: String(g['vehicleTypeName'] ?? g['VehicleTypeName'] ?? ''),
      subscriptions: subs.map((s) => this.mapSubscription(s)),
    };
  }

  private mapSubscription(dto: unknown): Rppk14SubscriptionGroup {
    const s = (dto ?? {}) as Record<string, unknown>;
    const cards = (s['cards'] ?? s['Cards'] ?? []) as unknown[];
    return {
      subscriptionId: Number(s['subscriptionId'] ?? s['SubscriptionId'] ?? 0),
      subscriptionName: String(s['subscriptionName'] ?? s['SubscriptionName'] ?? ''),
      cardCount: Number(s['cardCount'] ?? s['CardCount'] ?? 0),
      cards: cards.map((c) => this.mapCard(c)),
    };
  }

  private mapCard(dto: unknown): Rppk14CardRow {
    const c = (dto ?? {}) as Record<string, unknown>;
    return {
      seq: Number(c['seq'] ?? c['Seq'] ?? 0),
      cardId: Number(c['cardId'] ?? c['CardId'] ?? 0),
      cardName: String(c['cardName'] ?? c['CardName'] ?? ''),
      fullName: String(c['fullName'] ?? c['FullName'] ?? ''),
      licenses: String(c['licenses'] ?? c['Licenses'] ?? ''),
      subscriptionName: String(c['subscriptionName'] ?? c['SubscriptionName'] ?? ''),
      statusName: String(c['statusName'] ?? c['StatusName'] ?? ''),
      issueDate: (c['issueDate'] ?? c['IssueDate'] ?? null) as string | null,
      expireDate: (c['expireDate'] ?? c['ExpireDate'] ?? null) as string | null,
      clientName: String(c['clientName'] ?? c['ClientName'] ?? ''),
    };
  }

  private mapTotals(dto: unknown): Rppk14Totals {
    const t = (dto ?? {}) as Record<string, unknown>;
    return {
      cardCount: Number(t['cardCount'] ?? t['CardCount'] ?? 0),
    };
  }
}
